import initialState from 'redux/initial-states/organizations';
import currentOrganization from './currentOrganization';

export default (state = initialState, action = {}) => ({
  ...state,
  ...currentOrganization(state, action),
});
